import { render, staticRenderFns } from "./PageCategory.vue?vue&type=template&id=1a0fa92c&"
import script from "./PageCategory.vue?vue&type=script&lang=js&"
export * from "./PageCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0fa92c')) {
      api.createRecord('1a0fa92c', component.options)
    } else {
      api.reload('1a0fa92c', component.options)
    }
    module.hot.accept("./PageCategory.vue?vue&type=template&id=1a0fa92c&", function () {
      api.rerender('1a0fa92c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/category/PageCategory.vue"
export default component.exports